var mbtFormStyles = {
    'input': {
        'font-family': 'arial, sans-serif',
        'color': '#555',
        'display': 'block',
        'height': '36px',
        'padding': '0',
        'font-size': '16px',
        'line-height': '1.1em',
        'border': '1px solid #f00 !important'
    },
    'label': {
        'font-family': 'arial, sans-serif',
        'color': '#4e4948',
        'font-size': '15px',
        'font-weight': '700'
    },
    ':disabled': {'cursor': 'not-allowed'},
};

(function($) {

    formHelper.addRule({
        form: '#form-mbt-step-1',
        status: {
            SUCCESS: function() {

                window.redirectPost('/tools/main-menu/manual-booking-tool/step-2', {
                    'flex-response': this.data.flexResponseJSON
                });
            },
            SESSION_EXPIRED: '/tools/main-menu/manual-booking-tool/error',
            CAPTURE_CONTEXT_ERROR: '/tools/main-menu/manual-booking-tool/error',
            ERROR: function() {

                this.$form.find('#flex-response').val('');

                if (this.errors[0].code === 'NEWCAPTURECONTEXT') {

                    window.app.loadFlexMicroformScript(this.data.newCaptureContextData, mbtFormStyles);
                }

                lDialog.close();
            }
        },
        xhrReady: function(xhrOptions) {

            window.app.flexCreateToken(xhrOptions, this);
        }
    });

    formHelper.addRule({
        form: '#form-mbt-step-1-NoPayment',
        status: {
            SUCCESS: function() {
                window.redirectPost('/tools/main-menu/manual-booking-tool/step-2', {
                    'flex-response': this.data.flexResponseJSON
                });
            },
            SESSION_EXPIRED: '/tools/main-menu/manual-booking-tool/error',
            ERROR: function () {
                lDialog.close();
            }
        }
    });

})(jQuery);

jQuery(function initHandleMbtStep1Form($) {

    $('.form-mbt-step-1').each(function(index, el) {

        var $form           = $(this);
        var $submitBtn      = $form.find('.btn-submit');
        var $applyPromoBtn  = $form.find('.btn-apply-promocode');
        var $removePromoBtn = $form.find('.btn-remove-promocode');

        // Always execute when the form 1st gets init.
        calculateFinalPrice();

        window.app.initializeMicroform();

        var captureContextData = JSON.parse(captureContextDataJSON);

        window.app.loadFlexMicroformScript(captureContextData, mbtFormStyles);

        $form.keydown(function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        });

        $('.js-spacea-discount').click(function() {

            $(this).closest('.checkbox').siblings().find('.js-spacea-discount').prop('checked', false);
        });

        $applyPromoBtn.click(function() {

            promocode      = $('#promocode').val();
            originalprice  = $('#original-price').val();
            spaceadiscount = 0;

            $("input:checkbox[name=spacea-discount]:checked").each(function () {
                if($(this).is(':checked'))
                    spaceadiscount = $(this).val();
            });

            if (promocode !== '' && originalprice > 0) {

                $.ajax({
                    method: "POST",
                    url: "/h/mbt/ApplyPromoCode",
                    dataType: 'JSON',
                    data: { promocode: promocode, originalprice: originalprice, spaceadiscount: spaceadiscount },
                })
                    .done(function( data ) {

                        if (data.validPromo === 'yes') {
                            // Success
                            // Turn off
                            $('.js-fh-error-invalid-promocode').css('display','none');
                            $('.js-fh-error-invalid-promocode-req').css('display','none');
                            $('.js-promocode-apply').css('display','none');

                            // Turn on

                            finalPriceNum = data.finalPrice.replace("$", "");

                            $('.js-promocode-name').html(promocode);
                            $('.js-promocode-discount-amount').html(data.promocodeDiscount);
                            $('#promodiscount').val(data.promocodeDiscount);
                            $('#final-price').val(finalPriceNum);
                            $('.js-promocode-applied').css('display','block');

                            if (data.allowSpaceADiscount !== 'Y') {

                                // Make sure all "Apply R&R/SpaceA Discount" checkboxes are unchecked/disabled
                                $("input:checkbox[name=spacea-discount]").each(function () {

                                    $(this).prop('checked', false).prop('disabled', true);
                                });

                                $('.js-spacea-discount-checkboxes').addClass('disabled');
                                $('.js-spacea-discount-not-allowed').show();
                            }

                            // Validate the Booking form name
                            validateIsNoPaymentManualBookingForm(finalPriceNum);
                        }
                        else {
                            $('.js-fh-error-invalid-promocode').css('display','block');
                        }
                    })
                    .fail(function() {
                        alert( "An unexpected error has occurred." );
                    });
            }
            else {
                $('.js-fh-error-invalid-promocode-req').css('display','block');
            }
        });

        $removePromoBtn.click(function() {

            $.ajax({
                method: "POST",
                url: "/h/mbt/RemovePromoCode",
                dataType: 'JSON',
            })
                .done(function( data ) {
                    // Success
                    // Restore
                    $('.js-promocode-applied').css('display','none');
                    $('#promocode').val('');
                    $('#promodiscount').val('');

                    // Apply
                    $('.js-final-price').html(data.finalPrice);
                    $('.js-promocode-apply').css('display','block');


                    // Make sure all "Apply R&R/SpaceA Discount" checkboxes are unchecked/disabled
                    $("input:checkbox[name=spacea-discount]").each(function () {
                        $(this).prop('disabled', false);
                    });

                    $('.js-spacea-discount-checkboxes').removeClass('disabled');
                    $('.js-spacea-discount-not-allowed').hide();

                    calculateFinalPrice();

                })
                .fail(function() {
                    alert( "An unexpected error has occurred." );
                });
        });

        $submitBtn.click(function() {
            // Diaplay a lDialog loading shadow box
            checkValidityValue = $('.form-mbt-step-1')[0].checkValidity(); // returns true/false

            if(checkValidityValue === true) {
                // Browser checkValidity is true, load loading ldialog shadow box
                launchLoadingDialog();
            }
        });

        $('input[name=original-price]').change(function() {
            // Original Price onChange event
            calculateFinalPrice();
        });


        $('[name="spacea-discount"]').click( function() {
            // SpaceA Discount onClick event
            calculateFinalPrice();
        });

        function calculateFinalPrice() {

            // Calculate and set the final price
            var finalPrice = 0;
            var originalPrice = 0;
            var promoDiscount = 0;
            var spaceaDiscount = 0;

            originalPriceStr = $('#original-price').val().replace("$", "");
            if(parseFloat(originalPriceStr) > 0) {
                originalPrice = parseFloat(originalPriceStr);
            }

            if(originalPrice > 0) {

                promoDiscountStr = $('#promodiscount').val().replace("$", "");
                if(parseFloat(promoDiscountStr) > 0) {
                    promoDiscount = parseFloat(promoDiscountStr);
                }

                $("input:checkbox[name=spacea-discount]:checked").each(function () {
                    spaceaDiscount = parseFloat($(this).val());
                });
            }

            finalPrice = originalPrice - promoDiscount - spaceaDiscount;

            if (finalPrice < 0) {
                finalPrice = 0;
            }

            // Validate and set the booking form with finalPrice
            validateIsNoPaymentManualBookingForm(finalPrice);

            $('#final-price').val(finalPrice.toFixed(2));
        }

        // pickadate forms elements
        // ------------------
        $('#conf-date').pickadate({
            min: -365,
            max: true,
            selectYears: 2,
            selectMonths: true,
            labelMonthSelect: 'Select Month',
            labelYearSelect: 'Select Year',
            format: 'mm/dd/yyyy',
            formatSubmit: 'mm/dd/yyyy'
        });

        var $checkInData = $('#check-in-date').pickadate({
            max: 730,
            selectYears: 5,
            selectMonths: true,
            labelMonthSelect: 'Select Month',
            labelYearSelect: 'Select Year',
            format: 'mm/dd/yyyy',
            formatSubmit: 'mm/dd/yyyy'
        });
        var checkInDataPicker = $checkInData.pickadate('picker');

        var $checkOutDate = $('#check-out-date').pickadate({
            max: 730,
            selectYears: 5,
            selectMonths: true,
            labelMonthSelect: 'Select Month',
            labelYearSelect: 'Select Year',
            format: 'mm/dd/yyyy',
            formatSubmit: 'mm/dd/yyyy'
        });
        var checkOutDatePicker = $checkOutDate.pickadate('picker');

        // Check if there’s a “from” or “to” date to start with.
        if ( checkInDataPicker.get('value') ) {
            checkOutDatePicker.set('min', checkInDataPicker.get('select'));
        }

        if ( checkOutDatePicker.get('value') ) {
            checkInDataPicker.set('max', checkOutDatePicker.get('select'));
        }

        // When something is selected, update the "checkInData" and "checkOutDate" limits.
        checkInDataPicker.on('set', function(event) {
            if ( event.select ) {
                checkOutDatePicker.set('min', checkInDataPicker.get('select'));
            }
            else if ( 'clear' in event ) {
                checkOutDatePicker.set('min', false);
            }
        });

        checkOutDatePicker.on('set', function(event) {
            if ( event.select ) {
                checkInDataPicker.set('max', checkOutDatePicker.get('select'));
            }
            else if ( 'clear' in event ) {
                checkInDataPicker.set('max', false);
            }
        });

        function validateIsNoPaymentManualBookingForm(finalPrice) {

            // Check if the form should be a no cost submission
            if(parseInt(finalPrice) === 0) {
                // Rename form id to submit the NoPayment FH addRule
                if($("#form-mbt-step-1").length > 0) {
                    $('#form-mbt-step-1').attr('id','form-mbt-step-1-NoPayment');
                }

                // Remove NoPayment Info section
                $('.js-billing-information-block').css('display','none');
                $('.js-payment-information-block').css('display','none');

                // Remove required attributes
                $("#first-name-b").prop("required", false);
                $("#last-name-b").prop("required", false);
                $("#address1-b").prop("required", false);
                $("#city-b").prop("required", false);
                $("#state-province-b").prop("required", false);
                $("#postalcode-b").prop("required", false);
                $("#country-b").prop("required", false);
                $("#phone-b").prop("required", false);
            }
            else {
                // Rename form id to submit without NoPayment FH addRule
                if($('#form-mbt-step-1-NoPayment').length > 0) {
                    $('#form-mbt-step-1-NoPayment').attr('id','form-mbt-step-1');
                }

                // Restore NoPayment Info section
                $('.js-billing-information-block').css('display','block');
                $('.js-payment-information-block').css('display','block');

                // Add required attributes
                $("#first-name-b").prop("required", true);
                $("#last-name-b").prop("required", true);
                $("#address1-b").prop("required", true);
                $("#city-b").prop("required", true);
                $("#state-province-b").prop("required", true);
                $("#postalcode-b").prop("required", true);
                $("#country-b").prop("required", true);
                $("#phone-b").prop("required", true);
            }
        }

        jQuery(function($) {
            // Same as traveler info checkbox feature to copy and populate traveler info
            $('[name="same-as-traveler-info"]').click( function() {
                if($(this).is(':checked')) {
                    $('#first-name-b').val($('#first-name').val());
                    $('#last-name-b').val($('#last-name').val());
                    $('#address1-b').val($('#address1').val());
                    $('#address2-b').val($('#address2').val());
                    $('#city-b').val($('#city').val());
                    $('#state-province-b').val($('#state-province').val());
                    $('#postalcode-b').val($('#postalcode').val());
                    $('#country-b').val($('#country').val());
                    $('#phone-b').val($('#phone').val());
                }
            })
        });
    });
});

jQuery(function initHandleMbtStep2Form($) {
    $('#form-mbt-step-2').each(function(index, el) {

        var $container             = $(this);
        var $submitBtn		       = $container.find('.btn-submit');

        $submitBtn.click(function() {
            // Diaplay a lDialog loading shadow box
            checkValidityValue = $('#form-mbt-step-2')[0].checkValidity(); // returns true/false

            if(checkValidityValue === true) {
                // Browser checkValidity is true, load loading ldialog shadow box
                launchLoadingDialog();
            }
        });
    });
});